import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isFileUpload(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.FILE_UPLOAD && typeof label === 'string' && Array.isArray(value);
}
function _formatFileUpload(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatFileUpload(submission) {
  if (isFileUpload(submission)) {
    return _formatFileUpload(submission);
  }
  return undefined;
}
//# sourceMappingURL=file-upload-preview.js.map